// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./css/navbar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./css/modal.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./css/pages.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./css/table.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./css/patient.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./css/policy.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./css/tabs.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./css/language-selector.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./css/form.css";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./css/form-filter.css";
import ___CSS_LOADER_AT_RULE_IMPORT_10___ from "-!../../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./css/horizontal-bar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_11___ from "-!../../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./css/calendar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_12___ from "-!../../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./css/pupil.css";
import ___CSS_LOADER_AT_RULE_IMPORT_13___ from "-!../../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./css/chart.css";
import ___CSS_LOADER_AT_RULE_IMPORT_14___ from "-!../../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./css/select-button.css";
import ___CSS_LOADER_AT_RULE_IMPORT_15___ from "-!../../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./css/logo.css";
import ___CSS_LOADER_AT_RULE_IMPORT_16___ from "-!../../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./css/flashing-border.css";
import ___CSS_LOADER_AT_RULE_IMPORT_17___ from "-!../../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./css/dialog.css";
import ___CSS_LOADER_AT_RULE_IMPORT_18___ from "-!../../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./css/visualstrategydetails.css";
import ___CSS_LOADER_AT_RULE_IMPORT_19___ from "-!../../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./css/toast.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./img/bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_10___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_11___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_12___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_13___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_14___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_15___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_16___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_17___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_18___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styles for the app */ /* Using a string */ /* Using a string */ /* Using a string */ /* Using a string */ /* Using a string */ /* Using a string */ /* Using a string */ /* Using a string */ /* Using a string */ /* Using a string */ /* Using a string */ /* Using a string */ /* Using a string */ /* Using a string */ /* Using a string */ /* Using a string */ /* Using a string */ /* Using a string */ /* Using a string */ /* Using a string */

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/* ! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com */

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container{
  width: 100%;
}
@media (min-width: 640px){

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){

  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){

  .container{
    max-width: 1536px;
  }
}
.visible{
  visibility: visible;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.inset-0{
  inset: 0px;
}
.bottom-0{
  bottom: 0px;
}
.left-0{
  left: 0px;
}
.left-\\[22px\\]{
  left: 22px;
}
.left-\\[2px\\]{
  left: 2px;
}
.right-0{
  right: 0px;
}
.right-6{
  right: 1.5rem;
}
.top-0{
  top: 0px;
}
.top-4{
  top: 1rem;
}
.top-\\[2px\\]{
  top: 2px;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-\\[10000\\]{
  z-index: 10000;
}
.z-\\[9998\\]{
  z-index: 9998;
}
.z-\\[9999\\]{
  z-index: 9999;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-12{
  grid-column: span 12 / span 12;
}
.m-0{
  margin: 0px;
}
.m-1{
  margin: 0.25rem;
}
.m-auto{
  margin: auto;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3{
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-0{
  margin-top: 0px;
  margin-bottom: 0px;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-auto{
  margin-top: auto;
  margin-bottom: auto;
}
.-mt-2{
  margin-top: -0.5rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mr-4{
  margin-right: 1rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-\\[15px\\]{
  margin-top: 15px;
}
.box-border{
  box-sizing: border-box;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.h-5\\/6{
  height: 83.333333%;
}
.h-\\[150px\\]{
  height: 150px;
}
.h-\\[16px\\]{
  height: 16px;
}
.h-\\[22px\\]{
  height: 22px;
}
.h-\\[28px\\]{
  height: 28px;
}
.h-\\[4px\\]{
  height: 4px;
}
.h-\\[5px\\]{
  height: 5px;
}
.h-\\[80px\\]{
  height: 80px;
}
.h-\\[9px\\]{
  height: 9px;
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.max-h-60{
  max-height: 15rem;
}
.max-h-\\[88vh\\]{
  max-height: 88vh;
}
.min-h-0{
  min-height: 0px;
}
.min-h-\\[101px\\]{
  min-height: 101px;
}
.min-h-\\[250px\\]{
  min-height: 250px;
}
.min-h-\\[56px\\]{
  min-height: 56px;
}
.min-h-screen{
  min-height: 100vh;
}
.w-11\\/12{
  width: 91.666667%;
}
.w-2\\/4{
  width: 50%;
}
.w-3\\/4{
  width: 75%;
}
.w-48{
  width: 12rem;
}
.w-56{
  width: 14rem;
}
.w-60{
  width: 15rem;
}
.w-7{
  width: 1.75rem;
}
.w-8\\/12{
  width: 66.666667%;
}
.w-\\[16px\\]{
  width: 16px;
}
.w-\\[28px\\]{
  width: 28px;
}
.w-\\[300px\\]{
  width: 300px;
}
.w-\\[350px\\]{
  width: 350px;
}
.w-\\[42px\\]{
  width: 42px;
}
.w-\\[450px\\]{
  width: 450px;
}
.w-\\[9px\\]{
  width: 9px;
}
.w-auto{
  width: auto;
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.min-w-0{
  min-width: 0px;
}
.min-w-32{
  min-width: 8rem;
}
.min-w-40{
  min-width: 10rem;
}
.min-w-\\[150px\\]{
  min-width: 150px;
}
.min-w-\\[8px\\]{
  min-width: 8px;
}
.max-w-40{
  max-width: 10rem;
}
.max-w-44{
  max-width: 11rem;
}
.max-w-64{
  max-width: 16rem;
}
.max-w-full{
  max-width: 100%;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-initial{
  flex: 0 1 auto;
}
.flex-none{
  flex: none;
}
.shrink{
  flex-shrink: 1;
}
.flex-grow{
  flex-grow: 1;
}
.grow{
  flex-grow: 1;
}
.basis-48{
  flex-basis: 12rem;
}
.basis-80{
  flex-basis: 20rem;
}
.basis-96{
  flex-basis: 24rem;
}
.table-auto{
  table-layout: auto;
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-default{
  cursor: default;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.resize{
  resize: both;
}
.list-none{
  list-style-type: none;
}
.appearance-none{
  appearance: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12{
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.gap-0{
  gap: 0px;
}
.gap-2{
  gap: 0.5rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-\\[12px\\]{
  gap: 12px;
}
.gap-\\[14px\\]{
  gap: 14px;
}
.gap-\\[15px\\]{
  gap: 15px;
}
.gap-\\[20px\\]{
  gap: 20px;
}
.gap-\\[3px\\]{
  gap: 3px;
}
.gap-\\[6px\\]{
  gap: 6px;
}
.gap-\\[8px\\]{
  gap: 8px;
}
.gap-x-\\[14px\\]{
  column-gap: 14px;
}
.gap-y-\\[10px\\]{
  row-gap: 10px;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.self-stretch{
  align-self: stretch;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-visible{
  overflow: visible;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.overflow-y-hidden{
  overflow-y: hidden;
}
.text-ellipsis{
  text-overflow: ellipsis;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-line{
  white-space: pre-line;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-\\[10px\\]{
  border-radius: 10px;
}
.rounded-\\[11px\\]{
  border-radius: 11px;
}
.rounded-\\[20px\\]{
  border-radius: 20px;
}
.rounded-\\[25px\\]{
  border-radius: 25px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.border{
  border-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-dashed{
  border-style: dashed;
}
.border-none{
  border-style: none;
}
.border-\\[\\#FFB4A8\\]\\/50{
  border-color: rgb(255 180 168 / 0.5);
}
.border-transparent{
  border-color: transparent;
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/85{
  border-color: rgb(255 255 255 / 0.85);
}
.border-white\\/\\[0\\.16\\]{
  border-color: rgb(255 255 255 / 0.16);
}
.border-white\\/\\[0\\.34\\]{
  border-color: rgb(255 255 255 / 0.34);
}
.bg-\\[\\#00A58D\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 165 141 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#121D20\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(18 29 32 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#949595\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(148 149 149 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#B3382A\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(179 56 42 / var(--tw-bg-opacity, 1));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/45{
  background-color: rgb(0 0 0 / 0.45);
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/\\[0\\.03\\]{
  background-color: rgb(255 255 255 / 0.03);
}
.bg-white\\/\\[0\\.06\\]{
  background-color: rgb(255 255 255 / 0.06);
}
.bg-white\\/\\[0\\.14\\]{
  background-color: rgb(255 255 255 / 0.14);
}
.bg-white\\/\\[0\\.42\\]{
  background-color: rgb(255 255 255 / 0.42);
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-2{
  padding: 0.5rem;
}
.p-4{
  padding: 1rem;
}
.p-\\[16px\\]{
  padding: 16px;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-\\[10px\\]{
  padding-left: 10px;
  padding-right: 10px;
}
.px-\\[11px\\]{
  padding-left: 11px;
  padding-right: 11px;
}
.px-\\[12px\\]{
  padding-left: 12px;
  padding-right: 12px;
}
.px-\\[14px\\]{
  padding-left: 14px;
  padding-right: 14px;
}
.px-\\[16px\\]{
  padding-left: 16px;
  padding-right: 16px;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-\\[10px\\]{
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[6px\\]{
  padding-top: 6px;
  padding-bottom: 6px;
}
.py-\\[7px\\]{
  padding-top: 7px;
  padding-bottom: 7px;
}
.py-\\[8px\\]{
  padding-top: 8px;
  padding-bottom: 8px;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-5{
  padding-right: 1.25rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-\\[13px\\]{
  padding-top: 13px;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.font-\\[\\'Courier_New\\'\\2c monospace\\]{
  font-family: 'Courier New',monospace;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-6xl{
  font-size: 3.75rem;
  line-height: 1;
}
.text-8xl{
  font-size: 6rem;
  line-height: 1;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-light{
  font-weight: 300;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.lowercase{
  text-transform: lowercase;
}
.leading-\\[1\\.55\\]{
  line-height: 1.55;
}
.leading-\\[normal\\]{
  line-height: normal;
}
.leading-none{
  line-height: 1;
}
.tracking-\\[0\\.06em\\]{
  letter-spacing: 0.06em;
}
.tracking-\\[0\\.08em\\]{
  letter-spacing: 0.08em;
}
.text-\\[\\#00A58D\\]{
  --tw-text-opacity: 1;
  color: rgb(0 165 141 / var(--tw-text-opacity, 1));
}
.text-\\[\\#949595\\]{
  --tw-text-opacity: 1;
  color: rgb(148 149 149 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FFB4A8\\]{
  --tw-text-opacity: 1;
  color: rgb(255 180 168 / var(--tw-text-opacity, 1));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/60{
  color: rgb(255 255 255 / 0.6);
}
.underline{
  text-decoration-line: underline;
}
.no-underline{
  text-decoration-line: none;
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-\\[0\\.45\\]{
  opacity: 0.45;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_-14px_44px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\]{
  --tw-shadow: 0 -14px 44px rgba(0,0,0,0.5);
  --tw-shadow-colored: 0 -14px 44px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_14px_44px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.55\\)\\]{
  --tw-shadow: 0 14px 44px rgba(0,0,0,0.55);
  --tw-shadow-colored: 0 14px 44px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline{
  outline-style: solid;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[left\\]{
  transition-property: left;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150{
  transition-duration: 150ms;
}
.hover\\:bg-white\\/10:hover{
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:underline:hover{
  text-decoration-line: underline;
}
.hover\\:opacity-80:hover{
  opacity: 0.8;
}
.peer:focus-visible ~ .peer-focus-visible\\:ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.peer:focus-visible ~ .peer-focus-visible\\:ring-white\\/70{
  --tw-ring-color: rgb(255 255 255 / 0.7);
}
@media (max-width: 900px){

  .max-\\[900px\\]\\:w-\\[250px\\]{
    width: 250px;
  }
}
@media (max-width: 640px){

  .max-\\[640px\\]\\:hidden{
    display: none;
  }

  .max-\\[640px\\]\\:aspect-\\[16\\/9\\]{
    aspect-ratio: 16/9;
  }

  .max-\\[640px\\]\\:min-h-0{
    min-height: 0px;
  }

  .max-\\[640px\\]\\:w-full{
    width: 100%;
  }

  .max-\\[640px\\]\\:flex-col{
    flex-direction: column;
  }

  .max-\\[640px\\]\\:flex-wrap{
    flex-wrap: wrap;
  }

  .max-\\[640px\\]\\:gap-\\[10px\\]{
    gap: 10px;
  }

  .max-\\[640px\\]\\:px-\\[12px\\]{
    padding-left: 12px;
    padding-right: 12px;
  }

  .max-\\[640px\\]\\:py-\\[10px\\]{
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
@media (min-width: 640px){

  .sm\\:right-4{
    right: 1rem;
  }

  .sm\\:my-0{
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .sm\\:my-4{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .sm\\:mb-2{
    margin-bottom: 0.5rem;
  }

  .sm\\:mb-4{
    margin-bottom: 1rem;
  }

  .sm\\:ml-0{
    margin-left: 0px;
  }

  .sm\\:mr-0{
    margin-right: 0px;
  }

  .sm\\:mr-3{
    margin-right: 0.75rem;
  }

  .sm\\:mr-32{
    margin-right: 8rem;
  }

  .sm\\:mr-4{
    margin-right: 1rem;
  }

  .sm\\:mt-0{
    margin-top: 0px;
  }

  .sm\\:mt-32{
    margin-top: 8rem;
  }

  .sm\\:mt-4{
    margin-top: 1rem;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:w-1\\/4{
    width: 25%;
  }

  .sm\\:w-2\\/5{
    width: 40%;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:p-5{
    padding: 1.25rem;
  }

  .sm\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .sm\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .sm\\:pl-3{
    padding-left: 0.75rem;
  }

  .sm\\:pl-4{
    padding-left: 1rem;
  }

  .sm\\:pr-4{
    padding-right: 1rem;
  }

  .sm\\:pt-4{
    padding-top: 1rem;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-right{
    text-align: right;
  }

  .sm\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:font-medium{
    font-weight: 500;
  }
}
@media (min-width: 768px){

  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .md\\:mb-3{
    margin-bottom: 0.75rem;
  }

  .md\\:mr-0{
    margin-right: 0px;
  }

  .md\\:mr-32{
    margin-right: 8rem;
  }

  .md\\:mt-0{
    margin-top: 0px;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:w-2\\/5{
    width: 40%;
  }

  .md\\:w-3\\/5{
    width: 60%;
  }

  .md\\:w-4\\/12{
    width: 33.333333%;
  }

  .md\\:w-72{
    width: 18rem;
  }

  .md\\:min-w-52{
    min-width: 13rem;
  }

  .md\\:max-w-96{
    max-width: 24rem;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .md\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
}
@media (min-width: 1024px){

  .lg\\:absolute{
    position: absolute;
  }

  .lg\\:col-span-6{
    grid-column: span 6 / span 6;
  }

  .lg\\:my-0{
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .lg\\:my-2{
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .lg\\:mb-0{
    margin-bottom: 0px;
  }

  .lg\\:mr-32{
    margin-right: 8rem;
  }

  .lg\\:mt-0{
    margin-top: 0px;
  }

  .lg\\:mt-2{
    margin-top: 0.5rem;
  }

  .lg\\:mt-3{
    margin-top: 0.75rem;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:w-2\\/12{
    width: 16.666667%;
  }

  .lg\\:w-3\\/5{
    width: 60%;
  }

  .lg\\:w-80{
    width: 20rem;
  }

  .lg\\:min-w-96{
    min-width: 24rem;
  }

  .lg\\:max-w-2xl{
    max-width: 42rem;
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:items-center{
    align-items: center;
  }

  .lg\\:gap-6{
    gap: 1.5rem;
  }

  .lg\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .lg\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .lg\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .lg\\:pb-2{
    padding-bottom: 0.5rem;
  }

  .lg\\:pt-0{
    padding-top: 0px;
  }

  .lg\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .lg\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 1280px){

  .xl\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .xl\\:col-span-9{
    grid-column: span 9 / span 9;
  }

  .xl\\:-mt-7{
    margin-top: -1.75rem;
  }

  .xl\\:mr-32{
    margin-right: 8rem;
  }

  .xl\\:w-3\\/4{
    width: 75%;
  }

  .xl\\:w-80{
    width: 20rem;
  }

  .xl\\:w-full{
    width: 100%;
  }

  .xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:text-right{
    text-align: right;
  }
}
@media (min-width: 1536px){

  .\\32xl\\:mr-72{
    margin-right: 18rem;
  }

  .\\32xl\\:w-96{
    width: 24rem;
  }
}

:root {
  --blue: #00A58D;
  --white: #ffffff;
  --blue-dark: #00161D;
  --green-dark: #0A3D2D;
  --gray: #949595;
  --gray-light: #FFFFFFCC;
  --black: #000000;
}

body {
  font-family: 'Montserrat', sans-serif !important; /* Default font */
}
.font-montserrat {
  font-family: 'Montserrat', sans-serif !important; /* Default font */
}

.text-xxs{
  font-size: 10px
}

.color-primary{
  color: var(--blue);
}

.color-grey-light {
  color: var(--gray-light);
}

.bg-blue-dark{
  background: var(--blue-dark);
}

.bg-green-dark{
  background: var(--green-dark);
}

.bg-white{
  background: var(--white);
}

.bg-readonly {
  background: rgb(255, 255, 255, 0.1);
}

.txt-readonly {
  color: rgba(255, 255, 255, 0.8);
}

.bg-black{
  background: var(--black);
}

.bg-mimetika:before{
  content: ' ';
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.27;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size:1200px;
  background-position-x: -400px;
  background-position-y: -210px;
}

/* Responsive styles */
@media (max-width: 1500px) and (min-width: 775px) {
  .bg-mimetika:before{
    background-size:1450px;
  }
}


.App {
  text-align: center;
  background-color: #ffffff; /* Adjusted to match old website background rgb(239, 241, 247); /* Light grey background */
  font-family: 'Montserrat', sans-serif; /* Default font */
  color: #343a40; /*#333; /* Default text color */
  height: 100vh; /* Full viewport height */
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.font-montserrat{
  font-family: 'Montserrat', sans-serif !important; /* Default font */
}
.landing-page {
  display: flex;
  align-items: center;
  /*justify-content: center;*/
  height: 100vh;
}

/* Styles for the app logo */
.App-logo {
  height: 40vmin; /* Responsive height */
  pointer-events: none;
  animation: App-logo-spin infinite 20s linear; /* Rotating animation */
}

.logo-ojo{
  max-height: 80px !important
}

.logo-app {
  position: absolute;
  bottom: 0;
  width: auto !important;
  height: 50px;
  right: 0;
  max-width: inherit;
}

@media (max-width: 400px) {
  .logo-app {
    height: 35px;
  }
}

/* Keyframes for logo animation */
@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}



/* Styles for the info panel */
#infoPanel {
  text-align: left;
  font-style: italic;
  font-weight: bold;
  color:  #6c757d; /*rgb(126, 52, 52); /* Dark red text */
}

/* Link styles */
.App-link {
  color: #007bff; /* #61dafb; /* Light blue color */
}

/* Table container styles */
.table-container {
  overflow-y: auto;
  height: 400px; /* Custom height */
  margin: 20px;
}

/* Table styles */
table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #dee2e6; /*#ddd; /* Light grey border */
  padding: 8px;
  text-align: left;
}

th {
  background-color: #f4f4f4; /* Light grey background */
}

/* Table row hover effect */
.table-container table tbody tr:hover {
  background-color: #f2f2f2; /* Light grey background */
  cursor: pointer;
}

/* Layout styles */
.layout, .main-layout {
  display: flex;
  height: 100vh; /* Full viewport height */
}

/* Sidebar styles */
.sidebar {
  background-color:#343a40; /* Darker shade for sidebar */
  color: white;
  width: 250px; /* Fixed width */
  padding: 20px;
}

.sidebar ul, .sidebar-nav {
  list-style-type: none;
  padding: 0;
}

.sidebar ul li, .sidebar-nav li {
  margin: 10px 0;
}

/* Navigation item styles */
.nav-item, .nav-button {
  width: 100%;
  color: white;
  text-align: left;
  background-color: transparent;
  border: none;
  border-radius: 4px;
  padding: 10px;
  font-size: 18px;
  margin-bottom: 15px; /* More space between items */
  transition: background-color 0.2s;

}

.nav-item:hover {
  background-color: #34495e; /* Darker blue on hover */
  cursor: pointer;
}

/* Content area styles */
.content {
  flex-grow: 1;
  padding: 20px; /* Custom padding */
  background-color: #ecf0f1; /* Light grey background */
  overflow-y: auto;
}

/* Button styles */
.login-button {
  background-color: #343a40; /*#3498db; Blue background */
  color: white;
  border-radius: 9999px;
  border-width: 1px;
  border-color: transparent;
  padding: 0.75rem 1rem;
  font-size: 0.75rem;
  line-height: 1rem;
  letter-spacing: 0em;
  font-weight: 300;
  font-family: inherit;
}

.login-button:hover {
  opacity: 0.3
}


/* Button styles */
.logout-button {
  background-color: #343a40; /*#3498db; Blue background */
  color: white;
  border-radius: 9999px;
  border-width: 1px;
  border-color: transparent;
  padding: 0.75rem 1rem;
  font-size: 0.75rem;
  line-height: 1rem;
  letter-spacing: 0em;
  font-weight: 300;
  font-family: inherit;
}

.logout-button:hover {
  opacity: 0.3
}

/*
.button-table{
  border-radius: 5px;

}
*/

.show-measurement-button {
  background-color: #343a40; /* Choose your color */
  color: white; /* Text color */
  border: none;
}

.delete-button {
  background-color: transparent; /* Choose your color */
  color: var(--blue); /* Text color */
  border: none;
}
.delete-button:enabled:hover {
  opacity: 0.6;
  background: transparent;
  color: var(--blue);
  border: none;
}
.delete-button:focus {
  box-shadow: none;
}
.button-container {
  display: inline-block;
  margin-right: 10px; /* Adjust as needed */
}

/* Responsive styles */
@media (max-width: 768px) {
  .sidebar {
    width: 100%;
    height: auto;
  }

  .layout {
    flex-direction: column;
  }

  .content {
    height: auto;
  }
}



/* App.css - Add this at the bottom of your CSS file */
.logo-login {
  width: 100%
}
.logo {
  position: absolute;
  bottom: 10px;
  left: 10px;
  width: 100px; /* Adjust as necessary */
}

.min-w-40{
  min-width: 10rem;
}


.btn-primary {
  background: var(--blue);
  color: black;
  padding: 10px 30px;
  font-size: 10px;
  border-radius: 25px;
  font-weight: normal;
  border: none;
}
.btn-primary:hover {
  background: var(--gray);
  color: white;
}

.text-sm-8 {
  font-size: 8px;
}
.text-sm-10 {
  font-size: 10px;
}

/* Scrollbar styles */
div::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background: rgba(255, 255, 255, 0.23);
  border-radius: 5px;
}
/* Handle */
div::-webkit-scrollbar-thumb {
  background: var(--blue);
  border-radius: 5px;
  border: 1px solid white;
}

/*footer {*/
/*  position: absolute;*/
/*  bottom: 0;*/
/*  left: 0;*/
/*  right: 0;*/
/*}*/
footer.container-footer {
  width: 90%;
  border-color: rgba(255, 255, 255, 0.23);
}
footer > div {
  color: #9E9E9E;
  font-size: 10px;
  font-weight: 300;
}

.max-h-98 {
  max-height: 35rem;
}

.w-screen-60 {
  width: 40vw;
}

@media (max-width: 400px) {
  .max-h-98 {
    max-height: 25rem;
  }
}
.lifestyle-container {
  text-align: center;
  color: white;
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 10px;
  margin-top: 20px;
}

.image-item {
  cursor: pointer;
  border: 5px solid transparent;
  transition: border-color 0.3s;
}

.image-item.selected {
  border-color: white; /* Highlight selected images */
}

.image-item img {
  width: 100%;
  height: auto;
  display: block;
}

.tooltip-details {
  max-width: 300px;
  background-color: var(--blue);
  padding: 10px;
  border: 1px solid white;
  border-radius: 30px;
  font-size: 13px;
  transform: translateY(30%); /* empuja hacia abajo */

}
.tooltip-details div {
  background-color: var(--blue);
  border: none;
  box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,4BAA4B,EAEF,mBAAmB,EACpB,mBAAmB,EACnB,mBAAmB,EACnB,mBAAmB,EACjB,mBAAmB,EACpB,mBAAmB,EACrB,mBAAmB,EACN,mBAAmB,EAChC,mBAAmB,EACZ,mBAAmB,EAChB,mBAAmB,EACzB,mBAAmB,EACtB,mBAAmB,EACnB,mBAAmB,EACX,mBAAmB,EAC5B,mBAAmB,EACR,mBAAmB,EAC5B,mBAAmB,EACJ,mBAAmB,EAEnC,mBAAmB;;AAE5C;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd,kEAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AACnB;EAAA;AAAiB;AAAjB;EAAA;AAAiB;AAAjB;EAAA;AAAiB;AAAjB;EAAA,2GAAiB;EAAjB,yGAAiB;EAAjB;AAAiB;AAAjB;EAAA;AAAiB;AAAjB;;EAAA;IAAA;EAAiB;AAAA;AAAjB;;EAAA;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA,kBAAiB;IAAjB;EAAiB;;EAAjB;IAAA,iBAAiB;IAAjB;EAAiB;AAAA;AAAjB;;EAAA;IAAA;EAAiB;;EAAjB;IAAA,eAAiB;IAAjB;EAAiB;;EAAjB;IAAA,gBAAiB;IAAjB;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA,uBAAiB;IAAjB,oDAAiB;IAAjB;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA,iBAAiB;IAAjB;EAAiB;;EAAjB;IAAA,qBAAiB;IAAjB;EAAiB;;EAAjB;IAAA,kBAAiB;IAAjB;EAAiB;;EAAjB;IAAA,oBAAiB;IAAjB;EAAiB;;EAAjB;IAAA,kBAAiB;IAAjB;EAAiB;;EAAjB;IAAA,iBAAiB;IAAjB;EAAiB;;EAAjB;IAAA,mBAAiB;IAAjB;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA,mBAAiB;IAAjB;EAAiB;;EAAjB;IAAA,eAAiB;IAAjB;EAAiB;;EAAjB;IAAA;EAAiB;AAAA;AAAjB;;EAAA;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA,qBAAiB;IAAjB;EAAiB;;EAAjB;IAAA,kBAAiB;IAAjB;EAAiB;;EAAjB;IAAA,kBAAiB;IAAjB;EAAiB;AAAA;AAAjB;;EAAA;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA,eAAiB;IAAjB;EAAiB;;EAAjB;IAAA,kBAAiB;IAAjB;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA,kBAAiB;IAAjB;EAAiB;;EAAjB;IAAA,oBAAiB;IAAjB;EAAiB;;EAAjB;IAAA,oBAAiB;IAAjB;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA,mBAAiB;IAAjB;EAAiB;;EAAjB;IAAA,kBAAiB;IAAjB;EAAiB;AAAA;AAAjB;;EAAA;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;AAAA;AAAjB;;EAAA;IAAA;EAAiB;;EAAjB;IAAA;EAAiB;AAAA;;AAEjB;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gDAAgD,EAAE,iBAAiB;AACrE;AACA;EACE,gDAAgD,EAAE,iBAAiB;AACrE;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,yDAAqC;EACrC,4BAA4B;EAC5B,sBAAsB;EACtB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;AACF;;;AAGA;EACE,kBAAkB;EAClB,yBAAyB,EAAE,0FAA0F;EACrH,qCAAqC,EAAE,iBAAiB;EACxD,cAAc,EAAE,+BAA+B;EAC/C,aAAa,EAAE,yBAAyB;EACxC,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,gDAAgD,EAAE,iBAAiB;AACrE;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,cAAc,EAAE,sBAAsB;EACtC,oBAAoB;EACpB,4CAA4C,EAAE,uBAAuB;AACvE;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,sBAAsB;EACtB,YAAY;EACZ,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;;;AAIA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe,EAAE,sCAAsC;AACzD;;AAEA,gBAAgB;AAChB;EACE,cAAc,EAAE,iCAAiC;AACnD;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,aAAa,EAAE,kBAAkB;EACjC,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB,EAAE,0BAA0B;EACrD,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,aAAa,EAAE,yBAAyB;AAC1C;;AAEA,mBAAmB;AACnB;EACE,wBAAwB,EAAE,6BAA6B;EACvD,YAAY;EACZ,YAAY,EAAE,gBAAgB;EAC9B,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB,EAAE,6BAA6B;EAClD,iCAAiC;;AAEnC;;AAEA;EACE,yBAAyB,EAAE,yBAAyB;EACpD,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,aAAa,EAAE,mBAAmB;EAClC,yBAAyB,EAAE,0BAA0B;EACrD,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB,EAAE,4BAA4B;EACvD,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE;AACF;;;AAGA,kBAAkB;AAClB;EACE,yBAAyB,EAAE,4BAA4B;EACvD,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE;AACF;;AAEA;;;;;CAKC;;AAED;EACE,yBAAyB,EAAE,sBAAsB;EACjD,YAAY,EAAE,eAAe;EAC7B,YAAY;AACd;;AAEA;EACE,6BAA6B,EAAE,sBAAsB;EACrD,kBAAkB,EAAE,eAAe;EACnC,YAAY;AACd;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,kBAAkB,EAAE,qBAAqB;AAC3C;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;AACF;;;;AAIA,sDAAsD;AACtD;EACE;AACF;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY,EAAE,wBAAwB;AACxC;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;AACpB;AACA,WAAW;AACX;EACE,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,WAAW;AACX,wBAAwB;AACxB,eAAe;AACf,aAAa;AACb,cAAc;AACd,IAAI;AACJ;EACE,UAAU;EACV,uCAAuC;AACzC;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB,EAAE,8BAA8B;AACrD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,0BAA0B,EAAE,uBAAuB;;AAErD;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":["/* Base styles for the app */\n\n@import \"css/navbar.css\"; /* Using a string */\n@import \"css/modal.css\"; /* Using a string */\n@import \"css/pages.css\"; /* Using a string */\n@import \"css/table.css\"; /* Using a string */\n@import \"css/patient.css\"; /* Using a string */\n@import \"css/policy.css\"; /* Using a string */\n@import \"css/tabs.css\"; /* Using a string */\n@import \"css/language-selector.css\"; /* Using a string */\n@import \"css/form.css\"; /* Using a string */\n@import \"css/form-filter.css\"; /* Using a string */\n@import \"css/horizontal-bar.css\"; /* Using a string */\n@import \"css/calendar.css\"; /* Using a string */\n@import \"css/pupil.css\"; /* Using a string */\n@import \"css/chart.css\"; /* Using a string */\n@import \"css/select-button.css\"; /* Using a string */\n@import \"css/logo.css\"; /* Using a string */\n@import \"css/flashing-border.css\"; /* Using a string */\n@import \"css/dialog.css\"; /* Using a string */\n@import \"css/visualstrategydetails.css\"; /* Using a string */\n\n@import \"css/toast.css\"; /* Using a string */\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@tailwind screens;\n\n:root {\n  --blue: #00A58D;\n  --white: #ffffff;\n  --blue-dark: #00161D;\n  --green-dark: #0A3D2D;\n  --gray: #949595;\n  --gray-light: #FFFFFFCC;\n  --black: #000000;\n}\n\nbody {\n  font-family: 'Montserrat', sans-serif !important; /* Default font */\n}\n.font-montserrat {\n  font-family: 'Montserrat', sans-serif !important; /* Default font */\n}\n\n.text-xxs{\n  font-size: 10px\n}\n\n.color-primary{\n  color: var(--blue);\n}\n\n.color-grey-light {\n  color: var(--gray-light);\n}\n\n.bg-blue-dark{\n  background: var(--blue-dark);\n}\n\n.bg-green-dark{\n  background: var(--green-dark);\n}\n\n.bg-white{\n  background: var(--white);\n}\n\n.bg-readonly {\n  background: rgb(255, 255, 255, 0.1);\n}\n\n.txt-readonly {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.bg-black{\n  background: var(--black);\n}\n\n.bg-mimetika:before{\n  content: ' ';\n  display: block;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0.27;\n  background-image: url('./img/bg.png');\n  background-repeat: no-repeat;\n  background-size:1200px;\n  background-position-x: -400px;\n  background-position-y: -210px;\n}\n\n/* Responsive styles */\n@media (max-width: 1500px) and (min-width: 775px) {\n  .bg-mimetika:before{\n    background-size:1450px;\n  }\n}\n\n\n.App {\n  text-align: center;\n  background-color: #ffffff; /* Adjusted to match old website background rgb(239, 241, 247); /* Light grey background */\n  font-family: 'Montserrat', sans-serif; /* Default font */\n  color: #343a40; /*#333; /* Default text color */\n  height: 100vh; /* Full viewport height */\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n.font-montserrat{\n  font-family: 'Montserrat', sans-serif !important; /* Default font */\n}\n.landing-page {\n  display: flex;\n  align-items: center;\n  /*justify-content: center;*/\n  height: 100vh;\n}\n\n/* Styles for the app logo */\n.App-logo {\n  height: 40vmin; /* Responsive height */\n  pointer-events: none;\n  animation: App-logo-spin infinite 20s linear; /* Rotating animation */\n}\n\n.logo-ojo{\n  max-height: 80px !important\n}\n\n.logo-app {\n  position: absolute;\n  bottom: 0;\n  width: auto !important;\n  height: 50px;\n  right: 0;\n  max-width: inherit;\n}\n\n@media (max-width: 400px) {\n  .logo-app {\n    height: 35px;\n  }\n}\n\n/* Keyframes for logo animation */\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n\n/* Styles for the info panel */\n#infoPanel {\n  text-align: left;\n  font-style: italic;\n  font-weight: bold;\n  color:  #6c757d; /*rgb(126, 52, 52); /* Dark red text */\n}\n\n/* Link styles */\n.App-link {\n  color: #007bff; /* #61dafb; /* Light blue color */\n}\n\n/* Table container styles */\n.table-container {\n  overflow-y: auto;\n  height: 400px; /* Custom height */\n  margin: 20px;\n}\n\n/* Table styles */\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nth, td {\n  border: 1px solid #dee2e6; /*#ddd; /* Light grey border */\n  padding: 8px;\n  text-align: left;\n}\n\nth {\n  background-color: #f4f4f4; /* Light grey background */\n}\n\n/* Table row hover effect */\n.table-container table tbody tr:hover {\n  background-color: #f2f2f2; /* Light grey background */\n  cursor: pointer;\n}\n\n/* Layout styles */\n.layout, .main-layout {\n  display: flex;\n  height: 100vh; /* Full viewport height */\n}\n\n/* Sidebar styles */\n.sidebar {\n  background-color:#343a40; /* Darker shade for sidebar */\n  color: white;\n  width: 250px; /* Fixed width */\n  padding: 20px;\n}\n\n.sidebar ul, .sidebar-nav {\n  list-style-type: none;\n  padding: 0;\n}\n\n.sidebar ul li, .sidebar-nav li {\n  margin: 10px 0;\n}\n\n/* Navigation item styles */\n.nav-item, .nav-button {\n  width: 100%;\n  color: white;\n  text-align: left;\n  background-color: transparent;\n  border: none;\n  border-radius: 4px;\n  padding: 10px;\n  font-size: 18px;\n  margin-bottom: 15px; /* More space between items */\n  transition: background-color 0.2s;\n\n}\n\n.nav-item:hover {\n  background-color: #34495e; /* Darker blue on hover */\n  cursor: pointer;\n}\n\n/* Content area styles */\n.content {\n  flex-grow: 1;\n  padding: 20px; /* Custom padding */\n  background-color: #ecf0f1; /* Light grey background */\n  overflow-y: auto;\n}\n\n/* Button styles */\n.login-button {\n  background-color: #343a40; /*#3498db; Blue background */\n  color: white;\n  border-radius: 9999px;\n  border-width: 1px;\n  border-color: transparent;\n  padding: 0.75rem 1rem;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  letter-spacing: 0em;\n  font-weight: 300;\n  font-family: inherit;\n}\n\n.login-button:hover {\n  opacity: 0.3\n}\n\n\n/* Button styles */\n.logout-button {\n  background-color: #343a40; /*#3498db; Blue background */\n  color: white;\n  border-radius: 9999px;\n  border-width: 1px;\n  border-color: transparent;\n  padding: 0.75rem 1rem;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  letter-spacing: 0em;\n  font-weight: 300;\n  font-family: inherit;\n}\n\n.logout-button:hover {\n  opacity: 0.3\n}\n\n/*\n.button-table{\n  border-radius: 5px;\n\n}\n*/\n\n.show-measurement-button {\n  background-color: #343a40; /* Choose your color */\n  color: white; /* Text color */\n  border: none;\n}\n\n.delete-button {\n  background-color: transparent; /* Choose your color */\n  color: var(--blue); /* Text color */\n  border: none;\n}\n.delete-button:enabled:hover {\n  opacity: 0.6;\n  background: transparent;\n  color: var(--blue);\n  border: none;\n}\n.delete-button:focus {\n  box-shadow: none;\n}\n.button-container {\n  display: inline-block;\n  margin-right: 10px; /* Adjust as needed */\n}\n\n/* Responsive styles */\n@media (max-width: 768px) {\n  .sidebar {\n    width: 100%;\n    height: auto;\n  }\n\n  .layout {\n    flex-direction: column;\n  }\n\n  .content {\n    height: auto;\n  }\n}\n\n\n\n/* App.css - Add this at the bottom of your CSS file */\n.logo-login {\n  width: 100%\n}\n.logo {\n  position: absolute;\n  bottom: 10px;\n  left: 10px;\n  width: 100px; /* Adjust as necessary */\n}\n\n.min-w-40{\n  min-width: 10rem;\n}\n\n\n.btn-primary {\n  background: var(--blue);\n  color: black;\n  padding: 10px 30px;\n  font-size: 10px;\n  border-radius: 25px;\n  font-weight: normal;\n  border: none;\n}\n.btn-primary:hover {\n  background: var(--gray);\n  color: white;\n}\n\n.text-sm-8 {\n  font-size: 8px;\n}\n.text-sm-10 {\n  font-size: 10px;\n}\n\n/* Scrollbar styles */\ndiv::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n  background: rgba(255, 255, 255, 0.23);\n  border-radius: 5px;\n}\n/* Handle */\ndiv::-webkit-scrollbar-thumb {\n  background: var(--blue);\n  border-radius: 5px;\n  border: 1px solid white;\n}\n\n/*footer {*/\n/*  position: absolute;*/\n/*  bottom: 0;*/\n/*  left: 0;*/\n/*  right: 0;*/\n/*}*/\nfooter.container-footer {\n  width: 90%;\n  border-color: rgba(255, 255, 255, 0.23);\n}\nfooter > div {\n  color: #9E9E9E;\n  font-size: 10px;\n  font-weight: 300;\n}\n\n.max-h-98 {\n  max-height: 35rem;\n}\n\n.w-screen-60 {\n  width: 40vw;\n}\n\n@media (max-width: 400px) {\n  .max-h-98 {\n    max-height: 25rem;\n  }\n}\n.lifestyle-container {\n  text-align: center;\n  color: white;\n}\n\n.image-grid {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.image-item {\n  cursor: pointer;\n  border: 5px solid transparent;\n  transition: border-color 0.3s;\n}\n\n.image-item.selected {\n  border-color: white; /* Highlight selected images */\n}\n\n.image-item img {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.tooltip-details {\n  max-width: 300px;\n  background-color: var(--blue);\n  padding: 10px;\n  border: 1px solid white;\n  border-radius: 30px;\n  font-size: 13px;\n  transform: translateY(30%); /* empuja hacia abajo */\n\n}\n.tooltip-details div {\n  background-color: var(--blue);\n  border: none;\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
